var DataListItemTextAlign = {
  Left: "left",
  Right: "right",
  Center: "center",
  Justify: "justify",
  Initial: "initial",
  Inherit: "inherit"
};
var DataListItemVerticalAlign = {
  Baseline: "baseline",
  Sub: "sub",
  Super: "super",
  Top: "top",
  Middle: "middle",
  Bottom: "bottom",
  Initial: "initial",
  Inherit: "inherit"
};

export { DataListItemTextAlign, DataListItemVerticalAlign };
